import type { TrackDefinition } from '@internal/backstage-plugin-pulse-common';

export type TrackActionPermissions = {
  canEdit: boolean;
  canDelete: boolean;
  canRecertify: boolean;
};

export type TrackActionReasons = {
  editReason?: string;
  deleteReason?: string;
  recertifyReason?: string;
  documentationReason?: string;
  disabledKeys: string[];
};

/** Explains, per action, why it is disabled (if it is), for the actions menu. */
export const getTrackActionReasons = (
  track: TrackDefinition,
  { canEdit, canDelete, canRecertify }: TrackActionPermissions,
): TrackActionReasons => {
  let editReason: string | undefined;
  if (track.source !== 'db') {
    editReason = 'This track is defined in YAML and cannot be edited here';
  } else if (!canEdit) {
    editReason = 'Only the track owner or an admin can edit this track';
  }

  let deleteReason: string | undefined;
  if (track.source !== 'db') {
    deleteReason = 'This track is defined in YAML and cannot be deleted here';
  } else if (!canDelete) {
    deleteReason = 'Only the track owner or an admin can delete this track';
  }

  let recertifyReason: string | undefined;
  if (track.source !== 'db') {
    recertifyReason =
      'This track is defined in YAML and cannot be recertified here';
  } else if (!canRecertify) {
    recertifyReason =
      'Only the track owner or an admin can recertify this track';
  }

  const documentationReason = track.documentationUrl
    ? undefined
    : 'No documentation URL is configured for this track';

  const disabledKeys = [
    ...(editReason ? ['edit'] : []),
    ...(deleteReason ? ['delete'] : []),
    ...(recertifyReason ? ['recertify'] : []),
    ...(documentationReason ? ['documentation'] : []),
  ];

  return {
    editReason,
    deleteReason,
    recertifyReason,
    documentationReason,
    disabledKeys,
  };
};
